import { render, staticRenderFns } from "./BrandListEditModal.vue?vue&type=template&id=352dcb24&scoped=true&"
import script from "./BrandListEditModal.vue?vue&type=script&lang=js&"
export * from "./BrandListEditModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandListEditModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrandListEditModal.vue?vue&type=style&index=1&id=352dcb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352dcb24",
  null
  
)

export default component.exports